import {createContext, useEffect, useState} from "react";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // if page refreshed or user navigates away and comes back
    useEffect(() => {
        const email = localStorage.getItem("userEmail");
        if (email) {
            setUser({email});
            console.log("user set")
        } else {
            setUser(null);
        }
        setLoading(false);
    }, []);

    const login = async (email, token) => {
        setUser(email);
        // Store the token in local storage
        localStorage.setItem("token", token);
        // Store the user email in local storage
        localStorage.setItem("userEmail", email);
        console.log(user);
    };

    const logout = async () => {
        setUser(null);
        // Remove the token from local storage
        localStorage.removeItem("token");
        // Remove the user email from local storage
        localStorage.removeItem("userEmail");
        console.log(user);
    };

    return (
        <AuthContext.Provider value={{user, login, logout, loading}}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
